const STORAGE_KEY = 'inProgressGame:v1';

export type InProgressGame = {
    launcherUrl: string;
    pathname: string;
};

export const setInProgressGame = (game: InProgressGame): void => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(game));
    } catch {
        // Ignore quota / private browsing errors.
    }
};

export const getInProgressGame = (): InProgressGame | null => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return null;
        }

        const parsed = JSON.parse(raw) as InProgressGame;
        if (typeof parsed?.launcherUrl !== 'string' || typeof parsed?.pathname !== 'string') {
            return null;
        }

        return parsed;
    } catch {
        return null;
    }
};

export const clearInProgressGame = (): void => {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch {
        // Ignore storage errors.
    }
};
